import { inject, Injectable, ResourceRef } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RestApiService } from '@core/services/rest-api.service';
import { Entity } from '@shared/constants/entity';
import { map } from 'rxjs';
import {
  EnumDamageLocationDto,
  EnumDamageSeverityDto,
} from '../components/damage-reports-grid/interfaces';

@Injectable()
export class DamageReportsMetadataService {
  private api = inject(RestApiService);

  damageSeverityResource: ResourceRef<EnumDamageSeverityDto[] | undefined> =
    rxResource({
      stream: () =>
        this.api
          .getData<EnumDamageSeverityDto>({
            entity: Entity.EnumDamageSeverity,
            fields: ['DamageSeverityID', 'Description', 'TranslationKey'],
          })
          .pipe(map(resp => resp.data || [])),
    });

  damageLocationResource: ResourceRef<EnumDamageLocationDto[] | undefined> =
    rxResource({
      stream: () =>
        this.api
          .getData<EnumDamageLocationDto>({
            entity: Entity.EnumDamageLocation,
            fields: ['DamageLocationID', 'Description', 'TranslationKey'],
          })
          .pipe(map(resp => resp.data || [])),
    });
}
